import React from "react"
import { Button, Input, Pagination, Select, Spin, Table } from "antd"
import moment from "moment"
import commissions from "@services/commissions"
import mentors from "@services/mentors"
import { alertPopup } from "@utils/popup"
import download from "@utils/download"
import { fileExt } from '@texts/files'
import files from "@services/files"

class MentorCommissionReports extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            loadingCommissions: false,
            loadingMentors: false,
            loadingFile: false,
            mentors: [],
            commissions: [],
            searchBy: 'mentors_commissions_reports.mentor_id',
            filters: {
                report_date: `${new Date().getFullYear()}-${new Date().getMonth() < 9 ? '0' : ''}${new Date().getMonth() + 1}-01`,
                'mentors_commissions_reports.mentor_id': null,
                'mentors_commissions_reports.agent_id': null,
                'client.id': null
            },
            pagination: { page: 1, perPage: 10, total: 0, lastPage: 1 }
        }
    }
    
    componentDidMount(): void {
        this.getCommissionReports()
        this.getMentors()
    }

    getCommissionReports = () => {        

        this.setState({ loadingCommissions: true }, () => {
            commissions.getMentorCommissionReports({ filters: this.state.filters, pagination: this.state.pagination })
            .then((res) => {
                const { data, lastPage, page, perPage, total } = res.data
                this.setState({ commissions: data, pagination: { ...this.state.pagination, lastPage, page, perPage, total } })
            })
            .catch((error) => {
                console.log('error', error);
                alertPopup({ type: 'error', title: 'אירעה שגיאה', body: '' })
            })
            .finally(() => this.setState({ loadingCommissions: false }))
        })
    }

    getMentors = () => {
        this.setState({ loadingMentors: true }, () => {
            mentors.getAllMentors()
            .then((res) => {
                this.setState({ mentors: res.data })
            })
            .catch((error) => {
                console.log('error', error);
                alertPopup({ type: 'error', title: 'אירעה שגיאה בעת טעינת מנטורים', body: 'סינון לפי מנטורים עלול לא לעבוד' })
            })
            .finally(() => this.setState({ loadingMentors: false }))
        })
    }

    onSearchInput = ({ target: { id, value } }) => {
        if (id.includes('agent_id')) {
            this.setFilter('mentors_commissions_reports.agent_id', value)
        } else if (id.includes('client_id')) {
            this.setFilter('client.id', value)
        }
    }

    setFilter = (filter, value) => {
        this.setState({ filters: { ...this.state.filters, [filter]: value } })
    }

    balances = (balance) => {
        let obj = {
            CREDIT: { text: 'זכות', color: 'green' },
            DEBT: { text: 'חיוב', color: 'red' }
        }

        return obj[balance] || { text: balance, color: '' }
    }

    paymentTypes = (type) => {
        let obj = {
            YEARLY: 'שנתית',
            MONTHLY: 'חודשית',
            ONE_TIME: 'חד-פעמית',
            GENERAL_ONE_TIME: 'כללית, חד-פעמית'
        }

        return obj[type] || type
    }

    toLiteralMonth = (month) => {
        month = Number(month) - 1
        return new Date(null, month).toLocaleString('he-IL', { month: 'long' })
    }

    getYearMonth = (str) => {
        if (typeof str === 'string') {
            let them = str.split('-')
            return [them[0], them[1]]
        }
        return []
    }

    onDateSelect = (type, val) => {
        let arr = this.state.filters.report_date.split('-')
        let newStr = `${type === 'year' ? val : arr[0]}-${type === 'month' ? val : arr[1]}-01`
        this.setState({ filters: { ...this.state.filters, report_date: newStr } })
    }

    search = () => {
        this.setState({ pagination: { page: 1, perPage: 10, total: 0, lastPage: 1 } }, () => {
            this.getCommissionReports()
        })
    }

    resetFields = (search) => {
        this.setState({
            filters: {
                report_date: `${new Date().getFullYear()}-${new Date().getMonth() < 9 ? '0' : ''}${new Date().getMonth() + 1}-01`,
                'mentors_commissions_reports.mentor_id': null,
                'mentors_commissions_reports.agent_id': null,
                'client.id': null
            },
            pagination: { page: 1, perPage: 10, total: 0, lastPage: 1 }
        }, () => {
            if (search) this.getCommissionReports()
        })
    }

    paginate = (page, perPage) => {
        console.log('page perpage', page, perPage);
        this.setState({ pagination: { ...this.state.pagination, page, perPage } }, () => {
            this.getCommissionReports()
        })
    }

    generateFile = () => {
        this.setState({ loadingFile: true }, () => {
            commissions.mentorCommissionReportFile({ filters: this.state.filters })
            .then((res) => {
                this.downloadFile(res.data)
            })
            .catch((error) => {
                console.log('file errror', error);
                alertPopup({ type: 'error', title: 'אירעה שגיאה', body: '' })
            })
            .finally(() => this.setState({ loadingFile: false }))
        })
        
    }

    downloadFile = async (file) => {        
        const downloadedFile = await files
        .assert(file.file_url)
            // console.log('!!!!!!!!  CHANGE URL  !!!!!!!!');
            // .assert('http://localhost:3333/assets/local-media/151/mentors_commissions_reports.xlsx')
            .then(res => new Blob([res.data], { type: fileExt[file.file_ext] }))
        download(downloadedFile)
    }

    columns = [
        {
            title: 'מנטור',
            key: 'mentor_name',
            align: 'right',
            render: (record) => <span>{record.mentor_name}</span>
        },
        {
            title: 'מזהה סוכן',
            key: 'agent_id',
            align: 'right',
            render: (record) => <span>{record.agent_id}</span>
        },
        {
            title: 'שם הסוכן',
            key: 'agent_name',
            align: 'right',
            render: (record) => <span>{record.agent_name}</span>
        },
        {
            title: 'מזהה לקוח',
            key: 'client_id',
            align: 'right',
            render: (record) => <span>{record.client_id}</span>
        },
        {
            title: 'שם הלקוח',
            key: 'client_name',
            align: 'right',
            render: (record) => <span>{record.client_name}</span>
        },
        {
            title: 'מינוי',
            key: 'subscription_name',
            align: 'right',
            render: (record) => <span>{record.subscription_name}</span>
        },
        {
            title: 'מק״ט',
            key: 'sku',
            align: 'right',
            render: (record) => <span>{record.sku}</span>
        },
        {
            title: 'מחיר',
            key: 'amount',
            align: 'right',
            render: (record) => <span>{record.amount}</span>
        },
        {
            title: 'אחוז',
            key: 'percent',
            align: 'right',
            render: (record) => <span>{record.percent}</span>
        },
        {
            title: 'סוג עמלה',
            key: 'payment_type',
            align: 'right',
            render: (record) => <span>{this.paymentTypes(record.payment_type)}</span>
        },
        {
            title: 'זכות/חיוב',
            key: 'balance',
            align: 'right',
            render: (record) => <span style={{ color: this.balances(record.balance).color }}>{this.balances(record.balance).text}</span>
        },
        {
            title: 'חודשים לחיוב',
            key: 'months_to_charge',
            align: 'right',
            render: (record) => <span>{record.months_to_charge}</span>
        },
        {
            title: 'נכנס לדו״ח',
            key: 'report_date',
            align: 'right',
            render: (record) => <span>{moment(record.report_date).format('DD/MM/YYYY')}</span>
        },
    ]

    render () {
        const { loadingCommissions, loadingMentors, loadingFile, mentors, commissions, pagination } = this.state
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>

                <div style={{ display: 'flex', alignSelf: 'end' }}>
                    {loadingFile ?  <Spin style={{ margin: '6px 0 0 10px' }} /> : ''}
                    <Button onClick={this.generateFile}>{"יצירת קובץ"}</Button>
                </div>

                <div style={{ display: 'flex', margin: '20px 0' }}>
                    <div>
                        <span style={{ marginLeft: '6px' }}>{"מנטור: "}</span>
                        {loadingMentors ? <Spin size="small" style={{ margin: '0 10px 0 0' }}/> :
                        <Select
                            value={this.state.filters['mentors_commissions_reports.mentor_id']}
                            defaultValue={''}
                            onChange={(mentor_id) => this.setFilter('mentors_commissions_reports.mentor_id', mentor_id)}
                            style={{ width: '170px' }}
                            disabled={loadingMentors}
                        >
                            {mentors.map(({ id, name }) => {
                            return (
                                <Select.Option value={id} key={name}>
                                        {name}
                                </Select.Option>
                                )
                            })}
                            <Select.Option
                                value={''}
                                key={'all_mentors'}
                                >
                                {"כל המנטורים"}
                            </Select.Option>
                        </Select>}
                    </div>

                    <div style={{ ...style.inputLine }}>
                        <span style={{ marginLeft: '6px' }}>{"מזהה סוכן: "}</span>
                        <Input
                            value={this.state.filters['mentors_commissions_reports.agent_id']} id={"mentorReports-agent_id"}
                            onChange={this.onSearchInput}
                            style={{ width: '120px' }}
                        />
                    </div>

                    <div style={{ ...style.inputLine }}>
                        <span style={{ marginLeft: '6px' }}>{"מזהה לקוח: "}</span>
                        <Input
                            value={this.state.filters['client.id']} id={"mentorReports-client_id"}
                            onChange={this.onSearchInput}
                            style={{ width: '120px' }}
                        />
                    </div>

                    <div style={{ ...style.inputLine }}>
                        <span style={{ marginLeft: '6px' }}>{"שנה: "}</span>
                        <Select
                            style={{ width: '100px' }}
                            value={this.getYearMonth(this.state.filters['report_date'])[0]}
                            onChange={(val) => this.onDateSelect('year', val)}
                        >
                            {Array.from({ length: 15 }, (_, i) => 17 + i).map((val, idx) => {
                                return <Select.Option key={idx.toString()} value={val + 2000}>{val + 2000}</Select.Option>
                            })}
                        </Select>

                        <span style={{ margin: '0 30px 0 6px' }}>{"חודש: "}</span>
                        <Select
                            style={{ width: '100px' }}
                            value={this.getYearMonth(this.state.filters['report_date'])[1]}
                            onChange={(val) => this.onDateSelect('month', val)}
                        >
                            {['01','02','03','04','05','06','07','08','09','10','11','12'].map((val, idx) => {
                                return <Select.Option key={idx.toString()} value={val}>{this.toLiteralMonth(val)}</Select.Option>
                            })}
                        </Select>
                    </div>

                    <Button onClick={this.search} style={{ marginRight: '30px' }}>{"חיפוש"}</Button>
                    {loadingCommissions ? <Spin style={{ margin: '6px 20px 0 0' }} /> : ''}
                    <Button onClick={() => this.resetFields(true)} style={{ marginRight: 'auto' }}>{"איפוס"}</Button>
                </div>

                <Table
                    columns={this.columns}
                    dataSource={commissions}
                    pagination={false}
                />
                <Pagination
                    current={pagination.page}
                    pageSize={pagination.perPage}
                    total={pagination.total}
                    onChange={this.paginate}
                    style={{ margin: '20px 0 10px 0' }}
                />
                
            </div>
        )
    }
}

const style = {
    inputLine: { display: 'flex', alignItems: 'center', marginRight: '35px' }
}

export default MentorCommissionReports